import { render, staticRenderFns } from "./SideObjectPicture.vue?vue&type=template&id=64727688&scoped=true&"
import script from "./SideObjectPicture.vue?vue&type=script&lang=js&"
export * from "./SideObjectPicture.vue?vue&type=script&lang=js&"
import style0 from "./SideObjectPicture.vue?vue&type=style&index=0&id=64727688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64727688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64727688')) {
      api.createRecord('64727688', component.options)
    } else {
      api.reload('64727688', component.options)
    }
    module.hot.accept("./SideObjectPicture.vue?vue&type=template&id=64727688&scoped=true&", function () {
      api.rerender('64727688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/SideObjectPicture.vue"
export default component.exports